import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { useCarousel } from '@glowforge/gf-styled/hooks';
import TextAndImage from '@glowforge/gf-styled/components/text-and-image';

import {
  Wrapper,
  CarouselWrapper,
  PaginationWrapper,
  StyledTitle,
} from './testimonials.styles';

const Testimonials = ({ title, delay, testimonials, minHeightMobile }) => {
  const { carouselProps, Carousel, PaginationDots } = useCarousel(delay);
  const router = useRouter();
  const useMagicTitle = Boolean(router.pathname.match(/our-products-rebrand/i));

  return (
    <Wrapper variant='full' useMagicTitle={useMagicTitle}>
      {title ? <StyledTitle>{title}</StyledTitle> : null}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Carousel {...carouselProps} Wrapper={CarouselWrapper}>
        {testimonials.map(
          ({
            id,
            title: testimonialTitle,
            bodyContent,
            image,
            backgroundImage,
            backgroundColor,
            button,
            isQuote,
          }) => (
            <TextAndImage
              key={id}
              title={testimonialTitle}
              bodyContent={bodyContent}
              image={image}
              backgroundImage={backgroundImage}
              backgroundColor={backgroundColor}
              button={button}
              minHeightMobile={minHeightMobile}
              showQuote={isQuote}
            />
          )
        )}
      </Carousel>
      <PaginationWrapper>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <PaginationDots {...carouselProps} />
      </PaginationWrapper>
    </Wrapper>
  );
};

Testimonials.propTypes = {
  title: PropTypes.string,
  testimonials: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  delay: PropTypes.number.isRequired,
  minHeightMobile: PropTypes.string,
};

Testimonials.defaultProps = {
  title: '',
  minHeightMobile: '250px',
};

export default Testimonials;
